/* global axios */
import ApiClient from '../ApiClient';

class CaptainCredential extends ApiClient {
  constructor() {
    super('captain/credential', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.put(this.url, { credential: data });
  }
}

export default new CaptainCredential();
